/*
  Tab collections — prev/next arrows for the mobile product slider.
  The theme's <grid-slider> removes its arrows on touch devices, so mobile gets its own.
  Markup: sections/section-tab-collections.liquid, styles: assets/tabs.css
*/
if (!customElements.get('tab-collections-arrows')) {
  customElements.define(
    'tab-collections-arrows',
    class TabCollectionsArrows extends HTMLElement {
      connectedCallback() {
        this.slider = this.closest('.grid-outer')?.querySelector('.grid--mobile-slider');
        this.prev = this.querySelector('[data-arrow-prev]');
        this.next = this.querySelector('[data-arrow-next]');
        this.tabs = this.closest('tabs-component');
        if (!this.slider || !this.prev || !this.next) return;

        this.update = this.update.bind(this);
        this.onTabChange = () => requestAnimationFrame(this.update);

        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.slider.addEventListener('scroll', this.update, {passive: true});
        // Hidden tabs measure as 0 wide, so re-check once a tab is opened
        this.tabs?.addEventListener('theme:tab:change', this.onTabChange);

        // Card sizes can change after this first runs (tabs.css loads async below the fold, screen rotates),
        // so re-measure whenever the slider or its first product image changes size
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.slider);
        const image = this.slider.querySelector('[data-product-image]');
        if (image) this.resizeObserver.observe(image);

        this.update();
      }

      disconnectedCallback() {
        this.slider?.removeEventListener('scroll', this.update);
        this.tabs?.removeEventListener('theme:tab:change', this.onTabChange);
        this.resizeObserver?.disconnect();
      }

      // One product (card + gap) per click
      getStep() {
        const item = this.slider.querySelector('.grid-item');
        if (!item) return this.slider.clientWidth;

        return item.offsetWidth + (parseFloat(getComputedStyle(item).marginRight) || 0);
      }

      go(direction) {
        this.slider.scrollBy({left: direction * this.getStep(), behavior: 'smooth'});
      }

      update() {
        const {scrollLeft, scrollWidth, clientWidth} = this.slider;
        this.prev.disabled = scrollLeft <= 2;
        this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;

        // Centre the arrows on the product image rather than the whole card
        const image = this.slider.querySelector('[data-product-image]');
        if (image?.clientHeight) {
          this.style.setProperty('--button-position', `${image.clientHeight / 2}px`);
        }
      }
    }
  );
}
